import classNames from 'classnames';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  boxShadow, primaryFont, primaryHeadingColor, maxWidth, retina, wMedium, maxMobile,
} from 'Utils/utilsStyle';
import TagTip from './TagTip';

type Props = {
  personalDetails?: boolean;
  title?: string;
  keywords?: string[]
  icon: ReactNode;
};

const defaultProps = {
  personalDetails: false,
  keywords: [],
  title: '',
};

const Wrapper = styled.div` 
  &.personalDetails{
    border-radius: 16px !important;
    padding: 26px 15px 20px 25px !important;
    box-shadow: ${boxShadow};
    background-color: #fff;
    /* margin-bottom: 50px; */
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 12px !important;
      padding: 16px 24px 24px !important;
      margin-bottom: 0px;
    }
    @media all and (max-width: ${maxMobile}) {
      padding: 16px 24px 24px !important;
    }
    .heading {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 20px;
      letter-spacing: -0.42px;
      line-height: 30px;
      color: ${primaryHeadingColor};
      margin-bottom: 10;
      display : flex;
      align-items: center;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 18px;
        line-height: 26px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 16px;
        line-height: 18px;
      }
    }
    .tag-tip {
    .anticon-search {
      svg{
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
        }
      }
    }
    .tip-text {
      font-size: 14px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 12px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 11px;
      }
    }
  }
  }
`;

const IconHolder = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  h6 {
    margin-bottom: 0px;
    margin-left: 10px;
  }
`;

const PillsBlock: React.FC<Props> = function PillsBlock(props) {
  const {
    keywords, personalDetails, title, icon,
  } = props;

  return (
    <Wrapper className={classNames('pills-block-style-wrapper', { personalDetails })}>
      <IconHolder>
        {icon && icon}
        <h6 className="heading">{title}</h6>
      </IconHolder>
      {keywords?.map((item) => (
        <TagTip title={item} marginTopBottom="11px" marginTopBottomSm="3px" />
      ))}

    </Wrapper>
  );
};

PillsBlock.defaultProps = defaultProps;

export default PillsBlock;
